document.addEventListener('DOMContentLoaded', function () {
  if (typeof window.initCalendarPlanningDemo === 'function') {
    window.initCalendarPlanningDemo({
      year: new Date().getFullYear(),
      startDayOfWeek: 0,
      holidays: [
        { rule: 'fixed', date: '01-01', name: 'New Year\'s Day' },
        { rule: 'nthWeekdayOfMonth', month: 0, nth: 3, weekday: 1, name: 'Martin Luther King Jr. Day' },
        { rule: 'nthWeekdayOfMonth', month: 1, nth: 3, weekday: 1, name: 'President\'s Day' },
        { rule: 'fixed', date: '02-14', name: 'Valentine\'s Day' },
        { rule: 'fixed', date: '02-29', name: 'Leap Year Day' },
        { rule: 'fixed', date: '03-17', name: 'St. Patrick\'s Day' },
        { rule: 'lastWeekdayOfMonth', month: 4, weekday: 1, name: 'Memorial Day' },
        { rule: 'fixed', date: '04-20', name: 'Earth Day' },
        { rule: 'nthWeekdayOfMonth', month: 4, nth: 2, weekday: 0, name: 'Mother\'s Day' },
        { rule: 'fixed', date: '07-04', name: 'Independence Day' },
        { rule: 'nthWeekdayOfMonth', month: 5, nth: 3, weekday: 0, name: 'Father\'s Day' },
        { rule: 'nthWeekdayOfMonth', month: 7, nth: 1, weekday: 0, name: 'International Friendship Day' },
        { rule: 'nthWeekdayOfMonth', month: 8, nth: 1, weekday: 1, name: 'Labor Day' },
        { rule: 'fixed', date: '10-31', name: 'Halloween' },
        { rule: 'fixed', date: '11-11', name: 'Veteran\'s Day' },
        { rule: 'nthWeekdayOfMonth', month: 10, nth: 4, weekday: 4, name: 'Thanksgiving Day' },
        { rule: 'fixed', date: '12-24', name: 'Christmas Eve' },
        { rule: 'fixed', date: '12-25', name: 'Christmas Day' },
        { rule: 'fixed', date: '12-31', name: 'New Year\'s Eve' }
      ],
      events: [
        { start: '2024-04-15', end: '2024-04-19', name: 'Company Retreat' }
      ],
      vacations: [
        { start: '01-01', end: '01-03', name: 'Q4 Vacation (Part 2)' },
        { start: '06-23', end: '06-30', name: 'Q2 Vacation (Part 1)' },
        { start: '07-01', end: '07-07', name: 'Q2 Vacation (Part 2)' },
        { start: '12-19', end: '12-31', name: 'Q4 Vacation (Part 1)' }
      ]
    });
  }
});
